module.exports = __webpack_public_path__ + "static/media/ios-return-right.7970de06.svg";